import React from 'react'
import PropTypes from 'prop-types'

// STYLES // 
import './stylesCustombutton.scss'

function Custombutton({action, text}) {
  return (
    <button onClick={action} className='button'> {text} </button>
  )
}

Custombutton.propTypes = {}

export default Custombutton
